import React from 'react'
import EnhancedCandidatesList from './EnhancedCandidatesList'

/**
 * PlayerCandidates - Ehdokaslistan näyttäminen
 * Käyttää EnhancedCandidatesList-komponenttia, joka tarjoaa:
 * - Card-pohjaisen pelaajalistauksen
 * - Harjoitusasetusten validoinnin (vihreä/punainen status)
 * - Pelaajien lisäämisen ID:n perusteella
 * - Sorttauksen ja filtteröinnin
 */
const PlayerCandidates = () => {
  return <EnhancedCandidatesList />
}

export default PlayerCandidates
